import { useState } from "react";
import Countdown from "react-countdown";
import { Helmet } from "react-helmet";
import ProChip from "@/components/ProChip";
import CheckIcon from "@mui/icons-material/Check";
import TagFacesIcon from "@mui/icons-material/TagFaces";
import {PRO_ALERT_LIMIT} from "@/constants/membership";
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { SHOW_COUNT_DOWN_LIMIT } from "@/constants/config";
import { paymentSession } from "@/api/payment";
import { siteName } from "@/constants/config";
import { RenderFeatureMobile, RenderFeaturePC, RenderPromotion } from "@/components/ProInfo";
import { MONTHLY_MEMBERSHIP_PRICE, YEARLY_MEMBERSHIP_PRICE } from "@/constants/membership";
import {
  FREE_FLIGHT_RANGE,
  FREE_PANORAMA_RANGE,
  MAX_FLIGHT_RANGE,
  MAX_PANORAMA_SEARCH_DAYS,
} from "@/constants/membership";
import useEvent from "@/hooks/useEvent";
import useGlobalStore from "@/hooks/useGlobalStore";
import useNavigateLogin from "@/hooks/useNavigateLogin";
import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";
import useUserInfo from "@/hooks/useUserInfo";

import ServiceBanner from "./ServiceBanner";

const OurServices = () => {
  const theme = useThemeData();
  const { isMobile } = usePlatform();
  const isBreakPoint = useMediaQuery("(min-width:1200px)");

  const { navigateLogin } = useNavigateLogin();

  const { userInfoContext } = useUserInfo();

  const [personSpan, setPersonSpan] = useState("yearly-94");
  const { store } = useGlobalStore() as {
    store: { show_upsell: boolean; promotion: any };
  };

  const [open, setOpen] = useState(false);
  const [copyOpen, setCopyOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCopyClose = () => {
    setCopyOpen(false);
  };
  const handleCopyOpen = () => {
    setCopyOpen(true);
  };
  let beforeCode, afterCode, title, couponCode, priceOff, expireSec;
  priceOff = 0;
  if (store.promotion) {
    const text = store.promotion.text;
    couponCode = store.promotion.code;
    title = store.promotion.title;
    priceOff = store.promotion.off;
    expireSec = (store.promotion.expire - Math.floor(Date.now() / 1000)) * 1000;
  }
  let show_promotion = expireSec && expireSec > 0
  if (!show_promotion) {
    priceOff = 0;
  }
  // show_promotion = false;


  const yearly_price = (YEARLY_MEMBERSHIP_PRICE - (priceOff ? YEARLY_MEMBERSHIP_PRICE * priceOff / 100 : 0)).toFixed(2);
  const monthly_price = (MONTHLY_MEMBERSHIP_PRICE - (priceOff ? MONTHLY_MEMBERSHIP_PRICE * priceOff / 100 : 0)).toFixed(2);

  const monthly_total = MONTHLY_MEMBERSHIP_PRICE * 12;
  const save_amount = (parseFloat(monthly_total) - parseFloat(yearly_price)).toFixed(2);
  const save_percentage = Math.floor(((monthly_total - yearly_price) / monthly_total) * 100);
  const yearly_month_payment = (parseFloat(yearly_price) / 12).toFixed(2);

  const boxStyle = {
    width: "100%",
    minHeight: isBreakPoint ? "660px" : "auto",
    borderColor: theme.palette.divider,
    borderWidth: "2px",
    borderStyle: "solid",
    borderRadius: "6px",
  };
  const smallBoxStyle = {
    width: "100%",
    minHeight: "auto",
    borderColor: theme.palette.divider,
    borderWidth: "2px",
    borderStyle: "solid",
    borderRadius: "6px",
  };

  const getPaymentUrl = useEvent(async (params: { type: "business" | "person"; span: string }) => {
    try {
      const { url } = await paymentSession(params);
      return url;
    } catch (error) {
      console.error(error);
      return "";
    }
  });

  const getPersonPaymentUrl = useEvent(async () => {
    try {
      handleOpen();
      const url = await getPaymentUrl({ type: "person", span: personSpan });
      location.href = url;
      handleClose();
    } catch (error) {
      handleClose();
    }
  });

  const CODE = "PRO15";

  return (
    <div className="md:max-w-[1100px] md:m-auto !mt-[20px] ">
      <Helmet>
        <html lang="en" />
        <title>AwardTool | PRO</title>
        <meta name="description" content="Save thousands and hours easily with awardtool PRO." />
      </Helmet>
      <Paper
        sx={{
          boxShadow: 0,
          padding: "20px",
        }}
      >
        {store.show_upsell ? (
          <Typography className="!font-bold" color="primary" variant="h5">
            Let's go Pro!
          </Typography>
        ) : (
          <Typography className="!font-bold" color="primary" variant="h5">
            Hello, PRO!
          </Typography>
        )}
        <Typography variant="subtitle1" color="textSecondary" sx={{ fontStyle: "italic", mb: 1 }}>
          Widely regarded as the best award travel tool by experts and travelers alike
        </Typography>
        {/* {store.show_upsell && show_promotion && <RenderPromotion popup={true} has_max_width={false} borderThickness={2} />} */}
        <Grid container spacing={2} className="!mt-[-10px]">
          <Grid item lg={6} xs={12}>
            <Box sx={smallBoxStyle}>
              <div className="px-[20px] py-[15px]">
                <div className="flex justify-between items-center mb-[10px]">
                  <Typography fontSize={18} className="!font-bold">
                    Free Tier
                  </Typography>
                  <Chip label="Free" />
                </div>

                {/* <Typography fontSize={24} className="!font-bold !my-[10px]">
                  Free
                </Typography> */}
                {/* <Typography fontSize={18}>Give us a try — it’s free!</Typography> */}
                <Typography fontSize={16}>The Most Powerful Tool for Your Award Travel ✈️🔍💰</Typography>
              </div>
              <Divider light />

              <div className="px-[20px] py-[10px]">
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  Search on the fastest award search engine
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    Lightning
                    <Typography color="primary" className="inline !mx-[4px]">
                      {FREE_FLIGHT_RANGE + "-day"}
                    </Typography>
                    real-time search
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    Lightning{" "}
                    <Typography color="primary" className="inline !mx-[4px]">
                      multi-city
                    </Typography>{" "}
                    real-time search
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    Lightning{" "}
                    <Typography color="primary" className="inline !mx-[4px]">
                      roundtrip
                    </Typography>{" "}
                    real-time search
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    Access to{" "}
                    <Typography color="primary" className="inline !mx-[4px]">
                      {FREE_PANORAMA_RANGE + " days"}
                    </Typography>{" "}
                    of route data
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    {MAX_FLIGHT_RANGE + "-entry real-time search for"}
                    <Typography color="primary" className="inline !mx-[4px]">
                      15-day
                    </Typography>{" "}
                    period
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    <Typography color="primary" className="inline !mx-[4px]">
                      1 route request/refresh
                    </Typography>{" "}
                    every three day
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    <Typography color="primary" className="inline !mx-[4px]">
                      3 free award alerts
                    </Typography>{" "}
                  </div>
                </Typography>
                {/* <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <Typography className="inline">
                  Access yearly hotel calendar data{" "}
                  </Typography>
                  <Typography color="primary" className="inline !mx-[4px]">
                    3 times a day
                  </Typography>
                </Typography> */}
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    <Typography className="inline">Access yearly hotel calendar data </Typography>{" "}
                    <Typography color="primary" className="inline !mx-[4px]">
                      3 times a day
                    </Typography>{" "}
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    <Typography className="inline">Access to flight deals </Typography>{" "}
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  Advanced Filters
                </Typography>

                <div className="flex justify-center">
                  <Button
                    href="https://www.buymeacoffee.com/awardtool"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="!mt-[0px] !w-[100px] !h-[35px]"
                    variant="contained"
                    size="large"
                    sx={{ borderRadius: '16px' }}
                  >
                    Free ☕
                  </Button>
                </div>
              </div>
            </Box>
            {isMobile ? null : <Box className="mt-[10px]" sx={smallBoxStyle}>
              <div className="px-[20px] py-[10px]">

                <Typography fontSize={18} className="!font-bold">
                  {siteName + " for Developer"}
                </Typography>
                {/* <Typography fontSize={18}>Access Data with API</Typography> */}
              </div>
              <Divider light />

              <div className="px-[20px] py-[10px]">
                {/* <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  One Licensed Seat
                </Typography> */}
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  Highly reliable APIs with low latency
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  Access to millions of flight data at lighting speed
                </Typography>
                {/* <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  Access to real-time search
                </Typography> */}
                {/* <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  Dedicated feature requests
                </Typography> */}
                {/* <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  SkyView (30 day search)
                </Typography> */}
                {/* <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  600 SkyView Alerts (20 months)
                </Typography> */}
                {/* <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  Dedicated email & chat support
                </Typography> */}

                {/* <FormControl
                  className="w-[100%] !mt-[20px]"
                  sx={{
                    ".MuiFormControlLabel-root": {
                      marginX: 0,
                      borderColor: theme.palette.divider,
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderRadius: "6px",
                    },
                  }}
                >
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={businessSpan}
                    onChange={(e) => {
                      setBusinessSpan(e.target.value);
                      getBusinessPaymentUrl(e.target.value);
                    }}
                    name="radio-buttons-group"
                  >
                    <FormControlLabel
                      value="yearly"
                      control={<Radio />}
                      label={
                        <div>
                          <Typography fontSize={18}>$291.67 / month</Typography>
                          <Typography fontSize={14}>$3,499.99 - billed annually</Typography>
                          <Typography
                            fontSize={14}
                            className="animate__animated animate__bounce animate__infinite"
                          >
                            Save 27%!
                          </Typography>
                        </div>
                      }
                    />
                    <Divider className="!my-[10px]">or</Divider>
                    <FormControlLabel
                      value="monthly"
                      control={<Radio />}
                      label={<Typography fontSize={18}>$399.99 / month</Typography>}
                    />
                  </RadioGroup>
                </FormControl> */}

                <div className="text-center">
                  <Button
                    href={
                      "mailto:partnership@" +
                      siteName +
                      ".com?subject=API Access Application&body=We appreciate your interest in our API service. Kindly inform us about the specific API you require, the purpose behind your API access request, your intended use of the API, and the expected monthly request volume."
                    }
                    className="!mt-[0px] !w-[100px] !h-[35px]"
                    variant="contained"
                    size="large"
                    sx={{ borderRadius: '16px' }}
                  >
                    Contact Us
                  </Button>
                </div>
              </div>
            </Box>}
          </Grid>
          <Grid item lg={6} xs={12}>
            <Box sx={{ ...boxStyle, borderColor: theme.palette.info.main }}>
              <div className="px-[20px] py-[15px]">
                <div className="flex justify-between items-center mb-[18px]">
                  <Typography fontSize={20} className="!font-bold">
                    {siteName + " PRO"}
                  </Typography>
                  <div className="flex">
                    <Chip
                      label={title && show_promotion ? title : "Save thousands and hours!"}
                      color="primary"
                      className="mr-[10px]"
                    />
                    <Chip label="Pro" color="primary" className="ml-[1px]" sx={{ fontWeight: '700', borderRadius: 4, paddingY: 0 }} />
                  </div>
                </div>


                <div className="flex justify-center">
                  <Typography fontSize={16} className="flex items-center">Discover hidden award deals easily, save thousands and hours, and plan your award travel like a pro. ✈️
                  </Typography>
                </div>
              </div>



              <Divider light />

              <div className="px-[20px] py-[10px]">
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  Everything in free tier!
                </Typography>

                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    Search{" "}
                    <Typography color="primary" fontWeight={"bold"} className="inline !mx-[4px]">
                      365 days
                    </Typography>{" "}
                    of route data with <Typography color="primary" fontWeight={"bold"} className="inline !mx-[4px]">
                      {MAX_PANORAMA_SEARCH_DAYS + "-day range"}
                    </Typography>
                  </div>
                </Typography>
                {/* <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    Access to{" "}
                    <Typography color="primary" fontWeight={"bold"} className="inline !mx-[4px]">
                      365 days
                    </Typography>{" "}
                    of calendar view
                  </div>
                </Typography> */}
                {/* <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    Search wth
                    <Typography color="primary" fontWeight={"bold"} className="inline !mx-[4px]">
                      {MAX_PANORAMA_SEARCH_DAYS + "-day range"}
                    </Typography>
                    of routes data
                  </div>
                </Typography> */}
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    <Typography color="primary" fontWeight={"bold"} className="inline !mx-[4px]">
                      2 prioritized
                    </Typography>{" "}
                    route request/refresh everyday
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    <Typography color="primary" fontWeight={"bold"} className="inline !mx-[4px]">
                      {PRO_ALERT_LIMIT} award alerts with SMS notifications
                    </Typography>{" "}
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    <Typography color="primary" fontWeight={"bold"} className="inline !mx-[4px]">
                      {MAX_FLIGHT_RANGE + "-entry"}
                    </Typography>{" "}
                    real-time search for
                    <Typography color="primary" fontWeight={"bold"} className="inline !mx-[4px]">
                      365-day
                    </Typography>{" "}
                    period
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <Typography color="primary" fontWeight={"bold"} className="inline !mx-[4px]">
                    Unlimited 
                  </Typography>{" "}
                  live seat map

                </Typography>
                {/* <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    Search up to
                    <Typography fontWeight={"bold"} color="primary" className="inline !mx-[4px]">
                      {MAX_FLIGHT_RANGE + " days"}
                    </Typography>
                    real-time
                  </div>
                </Typography> */}
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    <Typography fontWeight={"bold"} color="primary" className="inline !mx-[4px]">
                      Unlimited
                    </Typography>
                    access to yearly hotel data
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <div>
                    <Typography fontWeight={"bold"} color="primary" className="inline !mx-[4px]">
                      Unlimited
                    </Typography>
                    access to millions of flight deals
                  </div>
                </Typography>
                <Typography fontSize={16} className="!mb-[10px] flex items-center">
                  <CheckIcon color="primary" className="mr-[6px]" />
                  <Typography color="primary" fontWeight={"bold"} className="inline !mx-[4px]">
                    Appreciation for your support! 😊 ❤️
                  </Typography>{" "}
                  {/* <TagFacesIcon color="primary" sx={{ fontSize: 20 }} /> */}
                </Typography>

                {show_promotion && store.promotion && store.show_upsell && expireSec ? (
                  <Typography fontWeight={"bold"} color="primary" fontSize={18} align="center">
                    <div className="mt-[8px]">
                      🎉 {title}{" "}
                      {expireSec < SHOW_COUNT_DOWN_LIMIT ? <div>
                        🔔 <Countdown date={Date.now() + expireSec} />
                      </div> : null}
                    </div>
                  </Typography>
                ) : null}
                {show_promotion && store.show_upsell &&
                  <div className="mt-[-2px] mb-[10px]">
                    <Typography fontWeight={"bold"} color="primary" fontSize={18} align="center">
                      
                        Save {priceOff}% with Code :{" "}
                        <Tooltip
                        placement="top"
                        sx={{ mr: 3 }}
                        title="Click to copy code"
                      >
                        <Typography
                          fontWeight={"bold"}
                          className="inline mt-[-5px]"
                          onClick={() => {
                            navigator.clipboard.writeText(couponCode);
                            handleCopyOpen();
                          }}
                          component={Button}
                          size="small"
                          color="primary"
                          fontSize={18}
                          sx={{ backgroundColor: 'rgba(25, 118, 210, 0.05)', borderRadius: 2, padding: '2px 8px', marginBottom: '5px' }}
                        >
                          {couponCode}
                        </Typography>

                      </Tooltip>
                    </Typography>
                    <div className="flex justify-center mt-[-6px] mb-[-12px]">
                      <Typography fontSize={16} color="primary" className="flex items-center">(First-time subscribers only)</Typography>
                    </div>
                  </div>}

                {/* <Divider light /> */}
                {store.show_upsell ? (
                  <div className={isMobile?"w-[95%] mx-auto":"w-[80%] mx-auto"}>
                    <FormControl
                      className="w-[100%] !mt-[10px]"
                      sx={{
                        ".MuiFormControlLabel-root": {
                          marginX: 0,
                          borderColor: theme.palette.divider,
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderRadius: "6px",
                        },
                      }}
                    >
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={personSpan}
                        onChange={async (e) => {
                          setPersonSpan(e.target.value);
                        }}
                        name="radio-buttons-group"
                      >
                        <FormControlLabel
                          value="monthly"
                          control={<Radio />}
                          label={
                            <div className="my-[10px]">
                              {/* <Typography sx={{ textDecoration: "line-through" }} fontSize={18}>
                              $12.99 / month or $155.88 / year
                            </Typography> */}
                              {priceOff ? <Typography
                                sx={{
                                  textDecoration: "line-through",
                                  fontWeight: "bold",
                                  marginTop: 1,
                                }}
                                color="textSecondary"
                                fontSize={18}
                              >
                                ${MONTHLY_MEMBERSHIP_PRICE + "  "} / month
                              </Typography> : null}
                              <Typography fontWeight={"bold"} color="primary" fontSize={18}>
                                ${monthly_price} / month
                                {priceOff ? (
                                  <Typography
                                    fontWeight={500}
                                    color="primary"
                                    fontSize={15}
                                    className="inline"
                                    sx={{ ml: 0.5 }}
                                  >
                                    {isMobile
                                      ? "  (renew at $" + MONTHLY_MEMBERSHIP_PRICE + "/month)"
                                      : "  (renew at $" + MONTHLY_MEMBERSHIP_PRICE + "/month)"}
                                  </Typography>
                                ) : (
                                  ""
                                )}
                              </Typography>
                            </div>
                          }
                        />
                        <FormControlLabel
                          value="yearly-94"
                          control={<Radio />}
                          label={
                            <div>
                              <Typography
                                sx={{
                                  textDecoration: "line-through",
                                  fontWeight: "bold",
                                  marginTop: 1,
                                }}
                                color="textSecondary"
                                fontSize={18}
                              >
                                ${monthly_total + "  "} / year
                              </Typography>

                              <Typography>
                                <Typography fontWeight={"bold"} color="primary" fontSize={18}>
                                  ${yearly_price} / year
                                  {priceOff ? (
                                    <Typography
                                      fontWeight={500}
                                      color="primary"
                                      fontSize={15}
                                      className="inline"
                                      sx={{ ml: 0.5 }}
                                    >
                                      {isMobile
                                        ? "  (renew at $" + YEARLY_MEMBERSHIP_PRICE + "/year)"
                                        : "  (renew at $" + YEARLY_MEMBERSHIP_PRICE + "/year)"}
                                    </Typography>
                                  ) : (
                                    ""
                                  )}
                                </Typography>
                                <div className="mt-[-5px]">
                                  {/* Code:{" "} */}


                                </div>
                                <Typography fontWeight={"bold"} color="primary" fontSize={18}>
                                  Just ${yearly_month_payment} / month!

                                </Typography>

                              </Typography>
                              {/* <Typography fontSize={14}>$99.99 - billed annually</Typography> */}
                              <Typography
                                fontSize={15}
                                color="primary"
                                sx={{ mb: 0.5, mt: 0.5 }}
                                className="animate__animated animate__bounce animate__infinite"
                              >
                                Save ${save_amount} - {save_percentage}% off 💵
                              </Typography>

                            </div>
                          }
                        />
                        {/* <Divider className="!my-[10px]">or</Divider> */}

                      </RadioGroup>
                    </FormControl>
                  </div>
                ) : null}

                {store.show_upsell ? (
                  <div className="text-center w-[80%] mx-auto mb-[20px] mt-[5px]">
                    <Button
                      className="!mt-[5px] w-[98%] mx-auto"
                      variant="contained"
                      sx={{ borderRadius: '12px' }}
                      onClick={() => {
                        if (!userInfoContext.userInfo) {
                          navigateLogin();
                          return;
                        }
                        getPersonPaymentUrl();
                      }}
                    >
                      <b>Upgrade Now! 🚀</b>
                    </Button>
                  </div>
                ) : null}

              </div>
              {!store.show_upsell ? (
                <div className="text-center">
                  <Button className="!mt-[20px]" variant="contained" sx={{ borderRadius: '12px' }}>
                    Enjoy Your Plan
                  </Button>
                </div>
              ) : null}
            </Box>
          </Grid>

        </Grid>
        <ServiceBanner />
      </Paper>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 4,
            boxShadow: 2,
            borderRadius: "12px",
          }}
        >
          <div className="text-center">
            <CircularProgress size={30} />
          </div>
          <Typography color="textPrimary">
            Thank you! 😊 We're redirecting you to payment page... 💳 ✨
          </Typography>
        </Box>
      </Modal>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={copyOpen}
        onClose={handleCopyClose}
        autoHideDuration={600}
      // message="I love snacks"
      // key={vertical + horizontal}
      >
        <Alert onClose={handleCopyClose} severity="success" sx={{ width: "100%" }}>
          Code copied successfully
        </Alert>
      </Snackbar>
    </div>
  );
};

export default OurServices;
